@if (!isMobile) {
    <div class="collection-report">
        <div class="donutCls" [chart]="donutChart"></div>
    </div>
}

@if (isMobile) {

}